import useUser from '../../components/use/user'

export const timezoneResolver = () => {
  useUser().setTimezone()
}
